import { Directive, OnInit } from '@angular/core';
import { Application } from '@modules/common/types/application';
import { StateKey } from '@modules/settings/types/state-key';
import { VirtualFolder } from '@modules/sheets/types/virtual-folder';
import { SheetsContextMenuComponent } from '../components/sheets-context-menu/sheets-context-menu.component';
import { DPContextMenuDirective } from './dp-context-menu.directive';

@Directive({
  selector: '[appDPSheetsContextMenu]',
  standalone: false,
})
export class SheetsContextMenuDirective
  extends DPContextMenuDirective<VirtualFolder, SheetsContextMenuComponent>
  implements OnInit
{
  protected override readonly application = Application.sheets;
  protected override readonly stateKey = StateKey.sheetsDPSidebarFilters;

  protected override registerComponent() {
    return SheetsContextMenuComponent;
  }
}
